export function preview(s, h) {
  const items = s.items || [];
  const p = s.pad === "sm" ? "1.5rem 2rem" : s.pad === "lg" ? "4.5rem 2rem" : "2.5rem 2rem";
  const cols =
    s.cols === "2"
      ? "repeat(2,1fr)"
      : s.cols === "3"
        ? "repeat(3,1fr)"
        : s.cols === "4"
          ? "repeat(4,1fr)"
          : "";
  const gs = cols
    ? `display:grid;grid-template-columns:${cols};gap:2rem;`
    : "display:flex;flex-wrap:wrap;gap:2.5rem;justify-content:center;";
  return `<div style="${h.ff}${h.fc}padding:${p};text-align:center;"><div style="${gs}">${items.map((it) => `<div><div style="font-size:clamp(2rem,6vw,3rem);font-weight:300;letter-spacing:-.02em;color:${h.accent};">${h.E(it.number || "0")}</div><div style="font-size:.6rem;font-weight:200;letter-spacing:.3em;text-transform:uppercase;color:${h.rgb(h.text, 0.5)};margin-top:.3rem;">${h.E(it.label || "")}</div></div>`).join("")}</div></div>`;
}
export function render(s, h) {
  const items = s.items || [];
  const p = s.pad === "sm" ? "1.5rem 2rem" : s.pad === "lg" ? "4.5rem 2rem" : "2.5rem 2rem";
  const cols =
    s.cols === "2"
      ? "repeat(2,1fr)"
      : s.cols === "3"
        ? "repeat(3,1fr)"
        : s.cols === "4"
          ? "repeat(4,1fr)"
          : "";
  const gs = cols
    ? `display:grid;grid-template-columns:${cols};gap:2rem;`
    : "display:flex;flex-wrap:wrap;gap:2rem;justify-content:center;";
  return `<div style="${h.ff}${h.fc}padding:${p};text-align:center;"><div style="${gs}">${items.map((it) => `<div><div class="stat-n" data-count="${h.A(it.number || "")}" style="font-size:clamp(2rem,6vw,3rem);font-weight:300;letter-spacing:-.02em;color:${h.accent};font-variant-numeric:tabular-nums;">${h.E(it.number || "")}</div><div style="font-size:.65rem;font-weight:200;letter-spacing:.2em;text-transform:uppercase;color:${h.rgb(h.text, 0.45)};margin-top:.35rem;">${h.E(it.label || "")}</div></div>`).join("")}</div></div>`;
}
